// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tech-banner {
  display: flex;
  width: 100vw;
  margin: 30px 0;
  /* max-width: 1024px; */
  /* overflow: scroll; */
}
`, "",{"version":3,"sources":["webpack://./src/components/elements/tech-banner/tech-banner.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,sBAAsB;AACxB","sourcesContent":[".tech-banner {\n  display: flex;\n  width: 100vw;\n  margin: 30px 0;\n  /* max-width: 1024px; */\n  /* overflow: scroll; */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
